export enum DataType {
  Accounting = "accounting",
  AccountingIntegration = "accountingIntegration",
  AccountingShort = "accountingShort",
  BankConnections = "bankConnections",
  BankStatement = "bankStatement",
  BankStatementDocument = "BankStatementDocument",
  BankStatementUploads = "bankStatementUploads",
  Banks = "banks",
  BulkPublishing = "bulkPublishing",
  ChartOfAccounts = "chartOfAccounts",
  Chaser = "chaser",
  Client = "client",
  Clients = "clients",
  CommunicationsQuery = "communicationsQuery",
  Company = "company",
  CompanyBillingDetails = "companyBillingDetails",
  ConnectionDuration = "connectionDuration",
  Department = "department",
  DisconnectMember = "disconnectMember",
  DocumentPreview = "documentPreview",
  DocumentQuery = "documentQuery",
  DocumentsStatus = "documentsStatus",
  EmailForwardingSender = "emailForwardingSender",
  EmailStatus = "emailStatus",
  HubSpotToken = "hubSpotToken",
  IntegrationAuth = "integrationAuth",
  IntegrationDisconnect = "integrationDisconnect",
  IntegrationRefresh = "integrationRefresh",
  Integrations = "integrations",
  InviteMember = "inviteMember",
  LineItemExtraction = "LineItemExtraction",
  LinkBusiness = "linkBusiness",
  MailAuth = "mailAuth",
  MailDisconnect = "MailDisconnect",
  Notification = "notification",
  Reconciliation = "reconciliation",
  Settings = "settings",
  Summary = "summary",
  Team = "members",
  Template = "template",
  Transaction = "transaction",
  Transactions = "transactions",
  Update = "update",
  UpdateWhatsappNumber = "updateWhatsappNumber",
  UploadDocuments = "uploadDocuments",
  User = "user",
  WhatsappDisconnect = "WhatsappDisconnect",
  WhatsappNumber = "whatsappNumber",
  WhatsappStatus = "whatsappStatus",
  YapilyAuth = "yapilyAuth"
}

export enum FeatureType {
  Bookkeeping = "bookkeeping",
  Communications = "communications",
  Integrations = "integrations",
  Organisation = "organisation",
  Reconciliation = "reconciliation",
  Settings = "settings",
  Util = "util"
}

export enum HttpMethod {
  Delete = "DEL",
  Get = "GET",
  Patch = "PATCH",
  Post = "POST",
  Put = "PUT"
}

export enum WhatsappIntegrationStages {
  ENTER_NUMBER,
  SUCCESS,
  UNKNOWN_NUMBER_INVITE,
  VERIFY_NUMBER
}
